export const ordersBasePath = 'commandes';
